<template>
    <div class="login-page register-page reset-pass">
        <div id="main-wrapper" class="w-100">
            <div v-if="success">
              <div class="mfp-bg animated zoomIn mfp-ready"></div>
              <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
                <div class="mfp-container mfp-s-ready mfp-inline-holder">
                  <div class="mfp-content">
                    <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                      <div class="content t-white t-center">
                         <p>{{$t('auth.confirmation_link')}}</p>
                      </div>
                      <div class="btn-holder t-center">
                        <a href="#" class="btn btn-lblue close-popup w-auto" @click.prevent="$router.push('/login')">{{$t('auth.ok')}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="registerFirst">
              <div class="mfp-bg animated zoomIn mfp-ready"></div>
              <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
                <div class="mfp-container mfp-s-ready mfp-inline-holder">
                  <div class="mfp-content">
                    <div id="upload-confirm" class="white-popup-block popup-content popup-small">
                      <div class="content t-white t-center">
                         <p>{{$t('auth.this_email_address')}}<a href="#" @click.prevent="registerFirst = false;$router.push('/register')">{{$t('auth.click_here')}}</a> {{$t('auth.create_account_now')}}</p>
                      </div>
                      <div class="btn-holder t-center">
                        <a href="#" class="btn btn-lblue close-popup w-auto" @click.prevent="registerFirst = false">{{$t('auth.ok')}} </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="login-page">
                <div class="register-holder center-div wow fadeIn">
                     <img width="145" src="assets/images/logo.svg" alt="" />
                    <br />
                    <br />
                    <div class="form-holder">
                        <h3 class="t-center">{{$t('auth.forgot_password')}}</h3>
                        <Form @submit="submit">
                            <ul>
                                <li>
                                    <label for="">{{$t('auth.email_address')}}</label>
                                    <Field class="form-control" name="Email address" rules="required|email" v-model="form.email" />
                                    <ErrorMessage name="Email address" />
                                </li>
                            </ul>
                            <div class="btn-holder">
                                <button class="btn btn-yellow">
                                    <span>{{$t('auth.submit')}}</span>
                                </button>
                            </div>
                        </Form>
                    </div>

                    <div class="links clearfix">
                        <div class="f-left t-left">
                            <p>{{$t('auth.already_have_account')}} <br /><router-link to="/login">{{$t('auth.login')}}</router-link></p>
                        </div>
                        <div class="f-right t-right">
                            <p>{{$t('auth.dont_have_account')}} <br /><router-link to="/register">{{$t('auth.create_account_now_CAP')}}</router-link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useMainStore } from "@/store";
    import { Form,Field, ErrorMessage } from "vee-validate";
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        mounted() {
            this.store.getCountriesList();
        },
        data() {
            return {
                form: {
                    email: "",
                },
                success : false,
                registerFirst : false
            };
        },
        components: {
            Form,
            Field,
            ErrorMessage,
        },
        methods: {
            submit() {
                this.store.forgotPassword(this.form, true,this);
            },
        },
    };
</script>
